import { SET_PAGE } from '../constants/index';
import { PageListenerState, PageListenerActions } from '../types/pageListenerTypes'

const initialState: PageListenerState = {
  currentLocation: '',
  previousLocation: ''
}

const pageListenerReducer = (state = initialState, action: PageListenerActions) => {
  const payload = action.payload
  switch(action.type){

    case SET_PAGE:
      return {
        ...state,
        currentLocation: payload.currentLocation,
        previousLocation: state.currentLocation
      }
    
    default: 
      return state
  }
}

export default pageListenerReducer;